import { StringUtils } from '@/utilities/Strings'
import { bannedIntegrationsForVendor } from "@/services/Context";

export let faIcons = {
    website: 'globe',
    mail: 'envelope',
    carousel: 'image',
    cards: 'th',
    bolt: 'bolt',
    bookmark: 'bookmark',
    rss: 'rss',
    discussion: 'comments',
    team: 'users',
    news: 'newspaper-o',
    filter: 'filter',
    check: 'check-circle',
    social: 'share-alt'
};

export let bgIcons = {
    amplify: 'amplify',
    everyone_social: 'everyone_social',
    buffer: 'buffer',
    funnelAmplified: 'funnelAmplified',
    hootsuite: 'hootsuite',
    industry_weapon: 'industry-weapon',
    hubspot: 'hubspot',
    mailchimp: 'mailchimp',
    proofpoint: 'proofpoint',
    sniply: 'sniply',
    shutterstock: 'shutterstock',
    zapier: 'zapier',
    icebreaker: 'icebreaker',
    getty: 'getty',
    constant_contact: 'constant_contact',
    openai: 'openai',
};

const normalizeKey = (s = '') =>
    s.toString().trim().toLowerCase()
        .replace(/[\s_]+/g, '-')  // spaces/underscores -> hyphen
        .replace(/-+/g, '-');  // collapse multiple hyphens

const bgKeyByNormalized = Object.keys(bgIcons).reduce((acc, k) => {
    acc[normalizeKey(k)] = k;
    return acc;
}, {});

export function getIconClass(icon) {
    const isFa = !!faIcons[icon];
    const isBg = !!bgIcons[icon];
    return isFa
        ? `fa fa-${faIcons[icon]}`
        : isBg
            ? `icon-dynamic ${bgIcons[icon]}-icon`
            : `fa fa-${icon}`;
}

export function getIconDescription(i) {
    if (i === 'hubspot') return 'HubSpot';
    if (i === 'rss') return 'RSS';
    return StringUtils.capitalizeWords(i.replace(/[-_]/g, ' '));
}

function buildAllowedIconKeys(vend) {
    const bannedRaw = bannedIntegrationsForVendor(vend) || [];
    const bannedBg = new Set(
        bannedRaw.map(normalizeKey).map(n => bgKeyByNormalized[n]).filter(Boolean)
    );

    const FA = Object.keys(faIcons);
    const BG = Object.keys(bgIcons).filter(k => !bannedBg.has(k) && k !== 'shutterstock');
    return [...FA, ...BG];
}

export function buildIconOptions(vend) {
    return buildAllowedIconKeys(vend).map(i => ({
        value: i,
        iconClass: getIconClass(i),
        label: getIconDescription(i),
    }));
}

export function getEntityIcon(type, id, store) {
    if (!type) return ''
    type = type.toLowerCase()
    if (type.startsWith('gallery')) return 'fa fa-globe'
    if (type === 'topic') return 'fa fa-th-list'
    if (type === 'collection') {
        const collection = store.getters.collections.find(c => c.id === id)
        const hasIcon = collection && collection.icon
        return hasIcon ? getIconClass(collection.icon) : 'fa fa-bolt'
    }
    return ''
}
